export default __webpack_public_path__ + "static/media/12.ba0b7c3c.png";